import { encodeUrl } from '../../helpers/CitrusHelper'

export const transformCarouselData = (data, categoryName, placement) => {
  return data.map(banner => {
    const landingPageLink = encodeUrl(categoryName, placement, banner?.citrusCampaignName)
    const link = banner?.gtins?.length === 1 ? `/product/${banner?.gtins[0]}` : landingPageLink

    return {
      altText: banner.heroImageAltText,
      desc: banner.bannerText,
      desktopImage: banner.heroImage,
      linkTarget: '_self',
      linkTitle: banner?.ctaText,
      linkUrl: banner?.ctaLink || link,
      mobileImage: banner.secondaryHeroImage,
      tabletImage: banner.heroImage,
      type: 'M020'
    }
  })
}
